"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TickCircleThinIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "37",
  height: "37",
  viewBox: "0 0 37 37",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-185.000000, -447.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(186.000000, 448.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.000000, -1.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            fill: color,
            fillRule: "nonzero",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M18.5,0.15 C28.6344252,0.15 36.85,8.36557484 36.85,18.5 C36.85,28.6344252 28.6344252,36.85 18.5,36.85 C8.36557484,36.85 0.15,28.6344252 0.15,18.5 C0.15,8.36557484 8.36557484,0.15 18.5,0.15 Z M18.5,1.85 C9.30445892,1.85 1.85,9.30445892 1.85,18.5 C1.85,27.6955411 9.30445892,35.15 18.5,35.15 C27.6955411,35.15 35.15,27.6955411 35.15,18.5 C35.15,9.30445892 27.6955411,1.85 18.5,1.85 Z M26.2474364,11.0729885 C26.5673116,10.7293963 27.1051583,10.7101698 27.4487506,11.0300451 C27.7637102,11.323264 27.8061124,11.7996396 27.5646068,12.1416528 L27.4916941,12.2313593 L14.7414069,25.9270115 C14.4332227,26.2580459 13.9268875,26.2855909 13.5857259,26.0096776 L13.4970499,25.9269048 L9.5082067,21.6408379 C9.18839033,21.2971909 9.20770894,20.7593475 9.55135602,20.4395311 C9.86636585,20.1463661 10.3445545,20.1381687 10.6684051,20.4035341 L10.7526629,20.4826804 L14.1194348,24.0991739 L26.2474364,11.0729885 Z"
            })
          })
        })
      })
    })
  })]
});

TickCircleThinIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = TickCircleThinIcon;
exports.default = _default;